<template>
  <!-- Page Content -->
  <div id='page-wrapper'>
    <vue-element-loading size='64' is-full-screen :active='isLoadingData' text='جارى تحميل بيانات العميل' spinner='bar-fade-scale' color='#A4A4A4'/>
    <div class='container-fluid'>
      <div class='row'>
        <div class='col-lg-12'>
          <h1 class='page-header'>إنشاء حوافظ</h1>
        </div>
        <!-- /.col-lg-12 -->
      </div>
      <!-- /.row -->
      <PrintReceipts ref="PrintReceipts"> </PrintReceipts>
      <div class='row'>
        <div class='col-lg-12'>
          <div class='panel panel-default'>
            <div class='panel-heading'>
            هنا يتم انشاء الحوافظ للإيصالات المصدرة و المرتجعة والمفقودة
            </div>
            <!-- /.panel-heading -->
            <div class='panel-body'>
              <div class='alert alert-danger alert-dismissable' style="margin: 10px 0px 0px 0px;" v-if='errorShow'>
                <ul v-if='validationErrors'>
                  <li v-for='err in validationErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
                </ul>
              </div>
              <div class="row">
                <div class='col-lg-3 col-md-6 col-sm-6'>
                  <label>الفرع</label>
                  <select @change="UpdateBranchData()" style="padding: 0px" class="form-control"  v-model="branch_id" >
                    <option v-for="item in branches" v-bind:key="item.id" v-bind:value="item.id">
                      {{ item.name }}
                    </option>
                  </select>
                </div>
                <div class='col-lg-3 col-md-6 col-sm-6'>
                  <label>الخط:</label>
                  <select @change="SetRegions()" class="form-control" style="padding: 0px" v-model="itinerarie_id">
                    <option v-for="item in itineraries" v-bind:key="item.id" v-bind:value="item.id">
                      {{ item.name }}
                    </option>
                  </select>
                </div>
                <div class='col-lg-3 col-md-6 col-sm-6'>
                  <label>المنطقة:</label>
                  <select class="form-control" style="padding: 0px" v-model="region_id">
                    <option v-for="item in regions" v-bind:key="item.id" v-bind:value="item.id">
                      {{ item.region_name }}
                    </option>
                  </select>
                </div>
                <div class='col-lg-3 col-md-3 col-sm-6'>
                  <div class="form-group">
                    <label>النوع</label>
                        <select class="form-control" style="padding: 0px" v-model="type_id">
                          <option v-for="item in types" v-bind:key="item.id" v-bind:value="item.id">
                            {{item.name}}
                          </option>
                        </select>
                  </div>
                </div>
                <div class='col-lg-3 col-md-3 col-sm-6'>
                  <tbDate :today='today' :mytitle='fromTitle' v-model= 'from_date' ></tbDate>
                </div>
                <div class='col-lg-3 col-md-3 col-sm-6'>
                  <tbDate :today='today' :mytitle='toTitle' v-model= 'to_date' ></tbDate>
                </div>
                <div class='col-lg-3 col-md-3 col-sm-6'>
                  <label>مسئول الاتصال:</label>
                <div class="form-group input-group">
                  <span class="input-group-btn">
                    <vue-element-loading size='32' :active='isgetTele' spinner='spinner' color='#A4A4A4'/>
                      <button
                        @click="getTele()" class="btn btn-default" type="button"><i class="fa fa-search"></i>
                      </button>
                  </span>
                  <select class="form-control" style="padding: 0px" v-model="tele_id">
                    <option v-for="item in teles" v-bind:key="item.id" v-bind:value="item.id">
                      {{ item.name }}
                    </option>
                  </select>
                  </div>
                </div>
                <div class='col-lg-3 col-md-3 col-sm-6'  >
                  <div class="form-group">
                    <label>الترتيب</label>
                    <select class="form-control" style="padding: 0px" v-model="sort">
                      <option value='cash_receipts.id'>رقم الايصال</option>
                      <option value='customers.region_id'>المنطقة</option>
                      <option value='customers.rec_id'>كود العميل</option>
                      <option value='customers.name'>الاسم</option>
                    </select>
                  </div>
                </div>
                <div class='col-lg-3 col-md-3 col-sm-6'  >
                  <span>&nbsp;</span>
                  <button @click='GetData(0)' type='button' class='btn btn-outline btn-primary btn-md btn-block '>
                    عرض ايصالات بدون حوافظ
                  </button>
                </div>
                <div class='col-lg-3 col-md-3 col-sm-6'  >
                  <span>&nbsp;</span>
                  <button @click='GetDistributedReceipts()' type='button' class='btn btn-outline btn-primary btn-md btn-block ' href="#CollectorsModal" role="button" data-toggle="modal">
                  توزيع الايصالات للفنيين
                  </button>
                </div>
                <div class='col-lg-3 col-md-3 col-sm-6'  >
                  <span>&nbsp;</span>
                  <button  @click="printReceipt(records, 1)" type='button' class='btn btn-outline btn-primary btn-md btn-block '>
                طباعة جميع الايصالات
                  </button>
                </div>
              </div>
              <br>
              <div>
                <table width='100%' class='table table-striped table-bordered table-hover' id='dataTables-example'>
                  <thead>
                    <tr>
                      <th style='text-align: center'>م</th>
                      <th style='text-align: center'>الكود</th>
                      <th style='text-align: center'>الاسم</th>
                      <th style='text-align: center'>الايصال</th>
                      <th style='text-align: center'>تاريخ الاصدار</th>
                      <th style='text-align: center'>التأجيل</th>
                      <th style='text-align: center'>النوع</th>
                      <th style='text-align: center'>الحالة</th>
                      <th style='text-align: center'>الاجراء</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class='odd gradeX' v-for='(record,index) in records' :key='index'>
                      <td align='center'> <i v-if='record.receipt_handles.length > 0'  data-toggle='modal' data-target='#OldHandelRecepts'  @click='showOldHandels(record)' class="fa fa-plus" ></i> {{index +1 }}</td>
                      <td align='center'>{{record.rec_id}}</td>
                      <td align='center'>{{record.customer_name}}</td>
                      <td align='center'>{{record.cash_receipt_id}}</td>
                      <td align='center'>{{record.create_date}}</td>
                      <td align='center'>{{record.delay}}</td>
                      <td align='center'>{{record.type_name}}</td>
                      <td align='center'>{{record.type}}</td>
                      <td align='center'>
                        <button v-show="$per.value.convertReceipt" @click='printReceipt(record, 0)' type='button' class='btn btn-outline btn-info btn-xs' >طباعة</button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- /.table-responsive -->
            </div>
            <!-- /.panel-body -->
          </div>
          <!-- /.panel -->
        </div>
        <!-- /.col-lg-12 -->
      </div>
    </div>
    <!-- Collectors Modal -->
    <div class='modal fade' id='CollectorsModal' tabindex='-1' role='dialog'  aria-labelledby='myModalLabel' aria-hidden='true'>
      <div class='modal-dialog  modal-lg'>
        <div class='modal-content'>
          <div class='modal-header'>
            <button type='button' class='close' data-dismiss='modal' aria-hidden='true'>&times;</button>
            <h4 class='modal-title' id='myModalLabel'>توزيع الايصالات على الفنيين</h4>
          </div>
          <form role='form'>
            <div class='modal-body'>
              <div class='alert alert-danger alert-dismissable' v-if='CollectorsvalidationErrors'>
                <ul v-if='CollectorsvalidationErrors'>
                  <li v-for='err in CollectorsvalidationErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
                </ul>
              </div>
              <div class='alert alert-success alert-dismissable' v-if='CollectorsSuccess'>
                {{CollectorsSuccess}}
              </div>
              <fieldset>
                <div class='form-group col-lg-4 col-sm-4'>
                  <label>الفرع:</label>
                  <select @change="GetDistributedReceipts()" style="padding: 0px" class="form-control"  v-model="branch_id" >
                    <option v-for="item in branches" v-bind:key="item.id" v-bind:value="item.id">
                      {{ item.name }}
                    </option>
                  </select>
                </div>
                <div class='form-group col-lg-4 col-sm-4'>
                  <label>الفنى:</label>
                  <select class="form-control" style="padding: 0px" v-model="modelCollectorId">
                    <option v-for="(item) in modelCollectors" v-bind:key="item.id" v-bind:value="item.id">
                      {{ item.name }}
                    </option>
                  </select>
                </div>
                <div class='form-group col-lg-4 col-sm-4'>
                  <tbDate :today='today' :mytitle='folderDate' v-model= 'folder_date' ></tbDate>
                </div>
                <div class='form-group col-lg-6 col-sm-6'>
                  <label>رقم الايصال:</label>
                  <input  @keypress="getRec($event)" v-model='id' ref="id" class='form-control' name='branchname' type='text'>
                </div>
                <div class='form-group col-lg-2 col-sm-2' style="padding-top: 23px">
                  <vue-element-loading size='32' :active='isLoadingSave' spinner='bar-fade-scale' color='#A4A4A4'/>
                  <button @click='saveData()' type='button' class='btn btn-primary btn-md btn-block'>حفظ</button>
                </div>
              </fieldset>
              <div>
                  <table width='100%' class='table table-striped table-bordered table-hover' id='dataTables-example'>
                    <thead>
                      <tr>
                        <th style='font-size: 16px;text-align: center'>م</th>
                        <th style='font-size: 16px;text-align: center'>الايصال</th>
                        <th style='font-size: 16px;text-align: center'>ك العميل</th>
                        <th style='font-size: 16px;text-align: center'>الاسم</th>
                        <th style='font-size: 16px;text-align: center'>المبلغ</th>
                        <th style='font-size: 16px;text-align: center'>الخط</th>
                        <th style='font-size: 16px;text-align: center'>الحركة</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr class='odd gradeX' v-for='(record,index) in CollectorRecords' :key='index'>
                        <td align='center'>{{index +1 }}</td>
                        <td align='center'>{{record.id}}</td>
                        <td align='right'>{{record.rec_id}}</td>
                        <td align='right'>{{record.name}}</td>
                        <td align='center'>{{record.amount}}</td>
                        <td align='center'>{{record.region_name}}</td>
                        <td align='center'>
                          <button @click='deleteRec(record.id)' type='button' class='btn btn-outline btn-danger btn-xs'>حذف</button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
              </div>
            </div>
            <div class='modal-footer'>
              <button type='button' class='btn btn-default' data-dismiss='modal'>خروج</button>
            </div>
          </form>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- /Collectors modal -->
    <!-- Modal OldHandelRecepts-->
    <div class='modal fade' id='OldHandelRecepts' tabindex='-1' role='dialog'  aria-labelledby='myModalLabel' aria-hidden='true'>
        <div class='modal-dialog  modal-lg'>
            <div class='modal-content'>
                <div class='modal-header'>
                    <button type='button' class='close'  data-toggle='modal' data-target='#OldHandelRecepts' aria-hidden='true'>&times;</button>
                    <h4 class='modal-title' id='myModalLabel'>حالات سابقة</h4>
                </div>
                <form role='form'>
                <div class='modal-body'>
                  <table width='100%' class='table table-striped table-bordered table-hover' id='dataTables-example'>
                    <thead>
                      <tr>
                        <th style='text-align: center'>م</th>
                        <th style='text-align: center'>الحافظة</th>
                        <th style='text-align: center'>الفنى</th>
                        <th style='text-align: center'>التأجيل</th>
                        <th style='text-align: center'>ملاحظات</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr class='odd gradeX' v-for='(record,index) in handeRecords' :key='index'>
                        <td align='center'>{{index +1 }}</td>
                        <td align='center'>{{record.folder_date}}</td>
                        <td align='center'>{{record.name}}</td>
                        <td align='center'>{{record.delay}}</td>
                        <td align='center'>{{record.notes}}</td>
                      </tr>
                    </tbody>
                  </table>
                  </div>
                  <div class='modal-footer'>
                      <button type='button' class='btn btn-default' data-toggle='modal' data-target='#OldHandelRecepts'>خروج</button>
                  </div>
                </form>
            </div>
            <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
    </div>
    <!-- /.modal OldHandelRecepts-->
    <!-- /.container-fluid -->
  </div>
</template>
<script>
import axios from 'axios'
import PrintReceipts from '@/components/Sales/PrintReceipts'
import DistributionReceipts from '@/components/Sales/DistributionReceipts'
import tbDate from '@/components/myComponents/tbDate'
export default {
  components: {
    DistributionReceipts,
    PrintReceipts,
    tbDate
  },
  name: 'CreateFolders',
  data () {
    return {
      types: [
        {id: 0, name: 'الكل'},
        {id: 1, name: 'سداد قسط فلتر'},
        {id: 2, name: 'تغيير شمع وسداد'},
        {id: 3, name: 'عرض جديد'},
        {id: 4, name: 'طلب صيانة'}
      ],
      receiptsBranch_id: null,
      type_id: 0,
      emptyRec: [{id: 0, name: ''}],
      sort: 'cash_receipts.id',
      today: true,
      toTitle: 'تاريخ الاصدار الى',
      folderDate: 'تاريخ الحافظة',
      fromTitle: 'تاريخ الاصدار من',
      from_date: '',
      to_date: '',
      folder_date: '',
      teles: [],
      tele_id: '',
      validationErrors: '',
      records: {},
      errorShow: false,
      isLoadingData: false,
      isLoadingSave: false,
      isgetTele: false,
      CollectorsSuccess: '',
      CollectorsvalidationErrors: '',
      branches: {},
      branch_id: 0,
      itineraries: 0,
      itinerarie_id: '',
      regions: '',
      region_id: 0,
      modelCollectors: {},
      collectors: {},
      CollectorRecords: [],
      handeRecords: '',
      collector_id: '0',
      modelCollectorId: '',
      cashReceipts: '',
      id: ''
    }
  },
  created () {
    this.branches = JSON.parse(localStorage.getItem('Branches'))
    this.branch_id = JSON.parse(localStorage.getItem('BrancheID'))
    this.UpdateBranchData()
  },
  methods: {
    UpdateBranchData () {
      this.collector_id = 0
      this.itinerarie_id = ''
      this.region_id = ''
      this.regions = ''
      this.records = ''
      let i = this.branches.findIndex(x => x.id === parseInt(this.branch_id))
      if (i > -1) {
        this.collectors = this.branches[i].collectors
        this.collectors.unshift(this.emptyRec)
        this.itineraries = this.branches[i].itineraries
        this.itineraries.unshift(this.emptyRec)
      }
    },
    SetRegions () {
      this.region_id = ''
      this.regions = null
      let i = this.branches.findIndex(x => x.id === parseInt(this.branch_id))
      if (i > -1) {
        let r = this.branches[i].itineraries.findIndex(x => x.id === parseInt(this.itinerarie_id))
        if (r > -1) {
          this.regions = this.branches[i].itineraries[r].regions
          this.regions.unshift(this.emptyRec)
        }
      }
    },
    // =====================================================
    getTele () {
      this.isgetTele = true
      axios.post(this.$apiURL + 'get-tele', {
        token: localStorage.getItem('token'),
        branch_id: this.branch_id,
        from_date: this.from_date,
        to_date: this.to_date
      })
        .then(({ data }) => {
          this.teles = data
          this.teles.unshift(this.emptyRec)
          this.isgetTele = false
        })
        .catch(err => {
          if (err) {
            this.isgetTele = false
          }
        })
    },
    // ===========================================================
    showOldHandels (rec) {
      this.handeRecords = rec.receipt_handles
    },
    // =====================================================
    GetDistributedByBarcode () {
      this.CollectorsSuccess = ''
      this.CollectorsvalidationErrors = ''
      this.isLoadingSave = false
      this.isLoadingData = true
      axios.post(this.$apiURL + 'get-distributed-receipts', {
        token: localStorage.getItem('token'),
        branch_id: this.branch_id
      })
        .then(({ data }) => {
          this.$refs.DistributionReceipts.loadCom(data.Cash_receipts, data.Collectors)
          this.isLoadingData = false
          this.successShow = true
          this.errorShow = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          this.validationErrors = err.response.data.errors
          this.successShow = false
          this.errorShow = true
          this.isLoadingData = false
        })
    },
    // =====================================================
    GetDistributedReceipts () {
      this.CollectorsSuccess = ''
      this.CollectorsvalidationErrors = ''
      this.isLoadingSave = false
      this.CollectorRecords = []
      this.cashReceipts = []
      this.isLoadingData = true
      axios.post(this.$apiURL + 'get-receipts-for-create-folder', {
        token: localStorage.getItem('token'),
        branch_id: this.branch_id
      })
        .then(({ data }) => {
          this.records = ''
          this.cashReceipts = data.Cash_receipts
          this.modelCollectors = data.Collectors
          this.isLoadingData = false
          this.successShow = true
          this.errorShow = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          this.validationErrors = err.response.data.errors
          this.successShow = false
          this.errorShow = true
          this.isLoadingData = false
        })
    },
    GetData (typeID) {
      this.isLoadingData = true
      axios.post(this.$apiURL + 'get-receipts-without-folders', {
        token: localStorage.getItem('token'),
        branch_id: this.branch_id,
        region_id: this.region_id,
        itinerarie_id: this.itinerarie_id,
        sort: this.sort,
        type_id: this.type_id,
        from_date: this.from_date,
        to_date: this.to_date,
        tele_id: this.tele_id
      })
        .then(({ data }) => {
          this.records = data
          this.isLoadingData = false
          this.successShow = true
          this.errorShow = false
          for (let i = 0; i < this.records.length; i++) {
            for (let c = 0; c < this.records[i].receipt_items.length; c++) {
              if (this.records[i].receipt_items[c].type === 1) {
                if (this.records[i].offers.length > 0) {
                  this.records[i].offers = this.records[i].offers + ' + ' + this.records[i].receipt_items[c].label
                } else {
                  this.records[i].offers = this.records[i].receipt_items[c].label
                }
              }
            }
          }
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          this.validationErrors = err.response.data.errors
          this.successShow = false
          this.errorShow = true
          this.isLoadingData = false
        })
    },
    // ===========================================================
    getReceiptsData () {
    },
    // ===========================================================
    async printReceipt (rec, typeId) {
      var xRate = 0
      var yRate = 0
      var paperSize = 0
      await axios.post(this.$apiURL + 'get-printer-rate', {
        token: localStorage.getItem('token'),
        id: this.branch_id
      })
        .then(({ data }) => {
          xRate = data.x_rate
          yRate = data.y_rate
          paperSize = data.paper_size
        })
      if (typeId === 0) {
        var Receipts = []
        Receipts.push(rec)
        if (paperSize === 0) {
          this.$refs.PrintReceipts.createPDF(Receipts, xRate, yRate)
        } else {
          this.$refs.PrintReceipts.CreatePDF_A5(Receipts, xRate, yRate)
        }
      } else {
        for (let i = 0; i < rec.length; i = i + 100) {
          if (paperSize === 0) {
            this.$refs.PrintReceipts.createPDF(rec.slice(i, i + 100), xRate, yRate)
          } else {
            this.$refs.PrintReceipts.CreatePDF_A5(rec.slice(i, i + 100), xRate, yRate)
          }
        }
      }
    },
    // ===========================================================
    getRec (evt) {
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if (charCode === 13) {
        evt.preventDefault()
        let i = this.cashReceipts.map(record => record.id).indexOf(parseInt(this.id))
        if (i > -1) {
          let r = this.CollectorRecords.map(record => record.id).indexOf(parseInt(this.id))
          if (r === -1) {
            this.CollectorRecords.push(Array.from(this.cashReceipts)[i])
            this.id = ''
          } else {
            this.$refs.id.select()
          }
        } else {
          this.$refs.id.select()
        }
      } else {
        return true
      }
    },
    // ===========================================================
    saveData () {
      let Receipts = []
      this.CollectorRecords.forEach(element =>
        Receipts.push(element.id)
      )
      this.CollectorsSuccess = ''
      this.CollectorsvalidationErrors = ''
      this.isLoadingSave = true
      axios.post(this.$apiURL + 'set-distributed-receipts', {
        token: localStorage.getItem('token'),
        CollectorId: this.modelCollectorId,
        folderDate: this.folder_date,
        receipts: Receipts
      })
        .then(res => {
          this.CollectorRecords = []
          this.isLoadingSave = false
          this.CollectorsSuccess = 'تم الحفظ بنجاح'
        })
        .catch(err => {
          if (err.response.data.message === 'Unauthenticated.') {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.CollectorsvalidationErrors = err.response.data.errors
          this.isLoadingSave = false
        })
    },
    // ===========================================================
    deleteRec (recID) {
      let i = this.CollectorRecords.map(record => record.id).indexOf(recID)
      this.CollectorRecords.splice(i, 1)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Sales/CreateFolders.vue